/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable prefer-destructuring */
import { pr } from '@/utils/pxToRem';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
import { genLinkSeo } from '@/utils/genLinkSeo';
import { FC } from 'react';

interface CompanyToRouteVcmsProps {
  startPoint?: any;
  toPoint?: any;
  airline?: string
  excludedAirlines?: string[]
}

export const Airlines_Name = {
  VN: 'Vietnam Airlines',
  VJ: 'Vietjet',
  QH: 'Bamboo',
  VU: 'Vietravel Airlines',
  BL: 'Pacific Airlines',

} as any;

export const Airlines_Code = {
  VN: 'vietnam-airlines',
  VJ: 'vietjet-air',
  QH: 'bamboo-airways',
  VU: 'vietravel-airlines',
  BL: 'pacific-airlines',
} as any;

const CompanyToRouteVcms: FC<CompanyToRouteVcmsProps> = (props) => {
  const {
    startPoint,
    toPoint,
    airline,
    excludedAirlines,
  } = props;
  let airlines = ['VN', 'VJ', 'QH', 'VU'];
  if (airline) {
    airlines = [Object.keys(Airlines_Code).find((code: any) => Airlines_Code[code] === airline) || ''];
  } else if (excludedAirlines) {
    airlines = airlines.filter((x) => !excludedAirlines.includes(x));
  }

  return (
    <Box
      sx={{
        marginTop: pr`16px`,
        display: 'flex',
        flexWrap: 'wrap',
        gap: '16px',
      }}
    >
      {airlines.map((airportCode: string) => {
        let contentText = '';
        if (startPoint && toPoint) {
          contentText = `Vé máy bay ${Airlines_Name[airportCode]} từ ${startPoint.location} đi ${toPoint.location}`;
        } else if (startPoint) {
          contentText = `Vé máy bay ${Airlines_Name[airportCode]} từ ${startPoint.location}`;
        } else if (toPoint) {
          contentText = `Vé máy bay ${Airlines_Name[airportCode]} đi ${toPoint.location}`;
        }

        return (
          <Link
            sx={{
              fontWeight: 500,
              width: '100%',
              textDecoration: 'none',
            }}
            target="_blank"
            href={genLinkSeo({
              startName: startPoint?.location,
              startId: startPoint?.id,
              startStateName: startPoint?.stateName,
              endName: toPoint?.location,
              endId: toPoint?.id,
              endStateName: toPoint?.stateName,
              company: Airlines_Code[airportCode],
            })}
            key={airportCode}
          >
            {contentText}
          </Link>
        );
      })}
    </Box>
  );
};

export default CompanyToRouteVcms;
